import { Link, useLoaderData } from 'react-router'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'

export const meta = () => {
    const title = "JaseOwns - Gaming - Ultima Online";
    const description = "Ultima Online came out in September 1997, I remember bugging my dad about getting it while playing Diablo 1 on Battle.NET as people online were talking about this new game.";
    return [
    { title: title },
    { description: description},
    { name: "keywords", content: "ultima online,creator,videos,uo,ultima online,1997"},
    { property: "og:image", content: "https://jaseowns.com/images/uo-feels.jpg"},
    { property: "og:image:alt", content: "Ultima Online Wallpaper"},
    { property: "twitter:card", content: "summary"},
    { property: "twitter:creator", content: "@jaseowns"},
    { property: "twitter:site", content: "@jaseowns"},
    { property: "og:title", content: title},
    { property: "og:description", content: description},
]}

export function loader() {

    const guidePlaylists = [ 

        {
            playlistUrl: "https://www.youtube.com/embed/playlist?list=PLogjLCROHXoINiKc-Zr4nu8f4OLuzQvdJ&pp=gAQB",
            title: "UO Outlands - New Player Guide - Solo Dex Tamer as Archer",
            description: "This playlist is for all the episodes of us being a brand new player to UO Outlands and making an archer bard character. We went healing and anamtomy but most people would have said go chiv! We cover how to play and enjoy the game without any help or scripts or overnight macroing - but then get into scripts to help us keep things barded.",
        },
        {
            playlistUrl: "https://www.youtube.com/embed/playlist?list=PLogjLCROHXoLeONIRWImdNpTVwwHZJKHo&si=u3JhidAACuT4kDyS",
            title: "UO Outlands - New Player Guide - Solo Archer Bard",
            description: "This playlist is for all the episodes of us being a brand new player to UO Outlands and making an archer bard character. We went healing and anamtomy but most people would have said go chiv! We cover how to play and enjoy the game without any help or scripts or overnight macroing - but then get into scripts to help us keep things barded.",
        },
        {
            playlistUrl: "https://www.youtube.com/embed/playlist?list=PLogjLCROHXoLAvopDRahES8eyvzofin8A",
            title: "UO Outlands - New Solo Player - Arcane Mage - Blood Aspect",
            description: "This playlist is for all the episodes of us being a brand new player on UO Outlands and making an arcane mage character.  We cover how to play and enjoy the game without any help or overnight macroing.",
        },
        {
            playlistUrl: "https://www.youtube.com/embed/playlist?list=PLogjLCROHXoLnqY7T0T-SxU-WRaS6RIIc",
            title: "UO Outlands - New Solo Player - Wrestling Dexxer - Fire Aspect",
            description: "This playlist is for all the episodes of us being a brand new player to UO Outlands and making a fire aspect wrestling character.  We cover how to play and enjoy the game without any help or scripts or overnight macroing.",
        },
        {
            playlistUrl: "https://www.youtube.com/embed/playlist?list=PLogjLCROHXoKoXMZ4M0liU2Ks2LhlqP58",
            title: "UO Outlands - New Solo Player - Scavanager",
            description: "This playlist is for all the episodes of us being a brand new player to UO Outlands and making a scavanger as our first character. You won't believe how much gold we make in the first days of of playing!",
        }
    ]
    
    return {
        guidePlaylists: guidePlaylists
    }
}

export default function NewPlayerIndex() {
    const {guidePlaylists } = useLoaderData<typeof loader>()
	return (
		<div className="container mx-auto text-black dark:text-white">
			<section id="gaming">
				<h1 className="text-3xl px-10 mb-8 text-cyan-900 dark:text-cyan-200">
                    <Link to="/gaming" className="underline">Gaming</Link> - <Link to="/gaming/ultima-online" className="underline">Ultima Online</Link> - New Player Guides
                </h1>                        
                <div className="mx-8 lg:px-4 my-2">
                    JaseOwns live streams on YouTube and Twitch and covers how to play multiple builds.
                </div>

                {
                    guidePlaylists.map((playlist) => (
                    <div key={playlist.title} className='clear-both mb-10'>
                        <div className="lg:float-left lg:w-1/2 m-2 px-4">
                            <div className="flex flex-col px-10 mb-6 max-w-4xl mx-auto">
                                <div className="iframe-container mt-4">
                                    <iframe src={playlist.playlistUrl} title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                </div>
                            </div>
                        </div>
                            <h2 className="text-3xl px-10 my-6 text-cyan-900 dark:text-cyan-200">{playlist.title}</h2>
                            <div className="mx-8 lg:px-4 my-4">
                                {playlist.description}
                            </div>
     
                        </div>
                    ))
                }

</section>

			<div className="flex flex-wrap justify-center gap-8 rounded-3xl py-4 clear-both">
				{WatchCTA()}
			</div>
		</div>
	)
}


